export default __webpack_public_path__ + "static/media/faceA.ccaffb77.png";